import React from 'react';
import spinner from './assets/spinner.gif';

export const MUSIC_NOTE = (
  <svg width="12" height="12">
    <circle cx="5" cy="9" r="3" />
    <rect height="9" width="2" x="6" />
    <rect height="2" width="5" x="6" />
  </svg>
);

export const MUSIC_NOTE_FILLED = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10ZM14 7H11V12.5C11 13.88 9.88 15 8.5 15C7.12 15 6 13.88 6 12.5C6 11.12 7.12 10 8.5 10C9.07 10 9.58 10.19 10 10.51V5H14V7Z"
      fill="#00243E"
    />
  </svg>
);

export const ICON_WIFI = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 9.00001L3 11C7.97 6.03001 16.03 6.03001 21 11L23 9.00001C16.93 2.93001 7.08 2.93001 1 9.00001ZM9 17L12 20L15 17C13.35 15.34 10.66 15.34 9 17ZM7 15L5 13C8.87 9.14001 15.14 9.14001 19 13L17 15C14.24 12.24 9.76 12.24 7 15Z"
      fill="#00243E"
    />
  </svg>
);

export const ICON_BELL = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 17V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V17H4V19H14H14.38H20V17H18ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17ZM14 20C14 21.1 13.1 22 12 22C10.9 22 10 21.1 10 20H14Z"
      fill="#00243E"
    />
  </svg>
);

export const ICON_RECORD = (
  <svg width="18" height="18" fill="none">
    <circle cx="9" cy="9" r="5" fill="white" />
    <circle cx="9" cy="9" r="8" stroke="white" strokeWidth="2" />
  </svg>
);

export const ICON_DOWNLOAD = (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 18.255L23.385 14.385L25.5 16.5L18 24L10.5 16.5L12.615 14.385L16.5 18.255V6H19.5V18.255ZM9 22.5H6V27C6 28.65 7.35 30 9 30H27C28.65 30 30 28.65 30 27V22.5H27V27H9V22.5Z"
      fill="#10293E"
    />
  </svg>
);

export const ICON_ARROW_UP = (
  <svg width="20" height="35" viewBox="0 0 20 35" fill="none">
    <path
      d="M10 33L10 3M10 3L2 10.9412M10 3L18 10.9412"
      stroke="#353639"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export const ICON_FACEBOOK = (
  <svg width="36" height="36" viewBox="0 0 36 36">
    <path
      d="M30 3H6C4.35 3 3.015 4.35 3.015 6L3 30C3 31.65 4.35 33 6 33H30C31.65 33 33 31.65 33 30V6C33 4.35 31.65 3 30 3ZM28.5 6V10.5H25.5C24.675 10.5 24 11.175 24 12V15H28.5V19.5H24V30H19.5V19.5H16.5V15H19.5V11.25C19.5 8.355 21.855 6 24.75 6H28.5Z"
      fill="#3B5998"
    />
  </svg>
);

export const ICON_TWITTER = (
  <svg width="36" height="36" viewBox="0 0 36 36">
    <path
      d="M30 3H6C4.35 3 3.015 4.35 3.015 6L3 30C3 31.65 4.35 33 6 33H30C31.65 33 33 31.65 33 30V6C33 4.35 31.65 3 30 3ZM26.565 13.995C26.475 20.925 22.035 25.665 15.435 25.965C12.705 26.085 10.725 25.215 9.015 24.12C11.025 24.435 13.53 23.64 14.865 22.485C12.885 22.29 11.715 21.285 11.175 19.665C11.745 19.77 12.345 19.74 12.885 19.62C11.1 19.02 9.825 17.925 9.765 15.615C10.26 15.84 10.785 16.05 11.475 16.095C10.125 15.345 9.15 12.57 10.275 10.74C12.255 12.915 14.64 14.685 18.555 14.925C17.58 10.725 23.145 8.445 25.47 11.265C26.46 11.07 27.255 10.695 28.02 10.29C27.705 11.265 27.09 11.94 26.34 12.495C27.15 12.39 27.885 12.18 28.5 11.88C28.125 12.675 27.285 13.395 26.565 13.995Z"
      fill="#3595D2"
    />
  </svg>
);

export const ICON_LIGHTBULB = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 3C12.21 3 7.5 7.71 7.5 13.5C7.5 17.07 9.285 20.205 12 22.11V25.5C12 26.325 12.675 27 13.5 27H22.5C23.325 27 24 26.325 24 25.5V22.11C26.715 20.205 28.5 17.07 28.5 13.5C28.5 7.71 23.79 3 18 3ZM13.5 31.5C13.5 32.325 14.175 33 15 33H21C21.825 33 22.5 32.325 22.5 31.5V30H13.5V31.5ZM21 20.55L22.275 19.65C24.3 18.24 25.5 15.945 25.5 13.5C25.5 9.36 22.14 6 18 6C13.86 6 10.5 9.36 10.5 13.5C10.5 15.945 11.7 18.24 13.725 19.65L15 20.55V24H21V20.55Z"
      fill="#00243E"
    />
  </svg>
);

export const ICON_SOUNDSENSING = (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M10 2C9.45 2 9 2.45 9 3V21C9 21.55 9.45 22 10 22C10.55 22 11 21.55 11 21V3C11 2.45 10.55 2 10 2Z"
      fill="#00243E"
    />
    <path
      d="M6 8C5.45 8 5 8.45 5 9V15C5 15.55 5.45 16 6 16C6.55 16 7 15.55 7 15V9C7 8.45 6.55 8 6 8Z"
      fill="#00243E"
    />
    <path
      d="M14 6C13.45 6 13 6.45 13 7V17C13 17.55 13.45 18 14 18C14.55 18 15 17.55 15 17V7C15 6.45 14.55 6 14 6Z"
      fill="#00243E"
    />
    <path
      d="M18 9C17.45 9 17 9.45 17 10V14C17 14.55 17.45 15 18 15C18.55 15 19 14.55 19 14V10C19 9.45 18.55 9 18 9Z"
      fill="#00243E"
    />
  </svg>
);

export const ICON_HEADPHONE = (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 11C3 6.03 7.03 2 12 2C16.97 2 21 6.03 21 11V18C21 19.66 19.66 21 18 21H15V13H19V11C19 7.13 15.87 4 12 4C8.13 4 5 7.13 5 11V13H9V21H6C4.34 21 3 19.66 3 18V11ZM7 15V19H6C5.45 19 5 18.55 5 18V15H7ZM19 15V18C19 18.55 18.55 19 18 19H17V15H19Z"
      fill="#00243E"
    />
  </svg>
);

export const ICON_SOUNDBARS = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="11" width="5" height="2" rx="1" fill="#00243E" />
    <rect x="7" y="7" width="5" height="2" rx="1" fill="#00243E" />
    <rect x="12" y="11" width="5" height="2" rx="1" fill="#00243E" />
    <rect x="17" y="15" width="5" height="2" rx="1" fill="#00243E" />
  </svg>
);

export const ICON_STAR = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 5.5L8 0L5.5 5.5L0 8L5.5 10.5L8 16L10.5 10.5L16 8L10.5 5.5Z"
      fill="white"
    />
  </svg>
);

export const ICON_SOUND = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2 4C3.1 4 4 4.9 4 6V10C4 11.1 3.1 12 2 12C0.9 12 0 11.1 0 10V6C0 4.9 0.9 4 2 4ZM12 6V10C12 11.1 12.9 12 14 12C15.1 12 16 11.1 16 10V6C16 4.9 15.1 4 14 4C12.9 4 12 4.9 12 6ZM6 2V14C6 15.1 6.9 16 8 16C9.1 16 10 15.1 10 14V2C10 0.9 9.1 0 8 0C6.9 0 6 0.9 6 2Z"
      fill="white"
    />
  </svg>
);

export const ICON_LIGHTBULB_FILLED = (
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none">
    <path
      d="M0.666992 5.6C0.666992 2.512 3.17899 0 6.26699 0C9.35499 0 11.867 2.512 11.867 5.6C11.867 7.504 10.915 9.176 9.46699 10.192V12C9.46699 12.44 9.10699 12.8 8.66699 12.8H3.86699C3.42699 12.8 3.06699 12.44 3.06699 12V10.192C1.61899 9.176 0.666992 7.504 0.666992 5.6Z"
      fill="white"
    />
    <path
      d="M4.66699 16C4.22699 16 3.86699 15.64 3.86699 15.2V14.4H8.66699V15.2C8.66699 15.64 8.30699 16 7.86699 16H4.66699Z"
      fill="white"
    />
  </svg>
);

export const ICON_PROCESSING = (
  <svg width="36" height="36" viewBox="0 0 36 36">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 33H19.5V3H16.5V33ZM10.5 27H13.5V9H10.5V27ZM7.5 21H4.5V15H7.5V21ZM22.5 27H25.5V9H22.5V27ZM28.5 21V15H31.5V21H28.5Z"
    />
  </svg>
);

export const ICON_DEVICE = (
  <svg width="36" height="36" viewBox="0 0 36 36">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 9H31.5V6H7.5C5.85 6 4.5 7.35 4.5 9V25.5H1.5V30H18V25.5H7.5V9ZM31.5 12H22.5C21.675 12 21 12.675 21 13.5V28.5C21 29.325 21.675 30 22.5 30H31.5C32.325 30 33 29.325 33 28.5V13.5C33 12.675 32.325 12 31.5 12ZM24 25.5H30V15H24V25.5Z"
    />
  </svg>
);

export const LOADER = (size = 24) => (
  <img src={spinner} width={size} height={size} alt="Loading" />
);
